import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { UserModel } from '../models/user.model'
import { AdministrationModel } from '../models/administration.model'

@Injectable()
export class AdministrationUsersService {
  private readonly url = environment.base_url + '/v1/administration'
  private readonly userUrl = environment.base_url + '/v1/user'

  params: any = {}

  constructor(private http: HttpClient) {}

  /**
   * Get list of users
   * @returns {Observable<Array<UserModel>>}
   */
  public list(administration: AdministrationModel): Observable<UserModel[]> {
    this.params.id = administration.id
    return this.http.get<UserModel[]>(`${this.url}/${administration.id}/users`)
  }

  /**
   * Get list of users
   * @returns {Observable<Array<AdministrationModel>>}
   */
  public listAdministrations(user: UserModel): Observable<AdministrationModel[]> {
    this.params.id = user.id
    return this.http.get<AdministrationModel[]>(`${this.userUrl}/${user.id}/administrations`)
  }

  /**
   * Update a User
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public access(user: UserModel): Observable<UserModel> {
    return this.http.put<UserModel>(`${this.url}/${user.id}`, user)
  }

  /**
   * Update a User
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public demote(user: UserModel): Observable<UserModel> {
    return this.http.put<UserModel>(`${this.url}/${user.id}`, user)
  }

  /**
   * Update a User
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public revoke(user: UserModel): Observable<UserModel> {
    return this.http.put<UserModel>(`${this.url}/${user.id}`, user)
  }

  /**
   * Update a User
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public invite(user: UserModel): Observable<UserModel> {
    return this.http.put<UserModel>(`${this.url}/${user.id}`, user)
  }

  /**
   * Resend activation link
   * @param {AdministrationModel} administration
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   *
   * /{id}/users/{userId}/resend-invite
   */
  public resendInvite(administration: AdministrationModel, user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(`${this.url}/${administration.id}/users/${user.id}/resend-invite`, {})
  }

  /**
   * Resend activation link
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  // public passwordReset(user: UserModel): Observable<UserModel>{
  //   return this.http.post<UserModel>(`${this._password_url}/request-reset`,{'email':user.email});
  // }
}



// WEBPACK FOOTER //
// ./src/app/main/services/administration-users.service.ts